module Meevo.Components.Controls {

    export interface SwapGroupServicePriceListItem {
        additionalCost: number;
        service_TId: string;
        objectState: number;
        homeLocationId: number;
        id: string;
        displayName: string;
        isDefault?: boolean;
    }


    export interface MarketModalOptions {
        data: SwapGroupServicePriceListItem[];
        serviceName: string;
        swapGroupServiceId: string;
        serviceShortcut: string
    }

    export class SwapGroupMarketsController {
        static $inject = [
            "meevo.AppSettings",
            "$mdDialog",
            "meevo.components.common.DataService",
            "options"
        ];

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            private $mdDialog: angular.material.IDialogService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private options: MarketModalOptions) {


        }

        $onInit() {

        }

        closeModal(e): void {
            if (e) e.stopPropagation();

            this.$mdDialog.hide();
        }

        applyChanges(e): void {
            if (e) e.stopPropagation();

            this.dataService.customMethodData("api/SwapGroupServicePrice/", "POST", {
                swapGroupServiceId: this.options.swapGroupServiceId,
                priceGroupAdditionalCostList: this.options.data.map(row => {
                    return {
                        priceGroupId: row.id,
                        additionalCost: row.additionalCost
                    }
                })
            });

            const defaultMarket = this.options.data.find((item) => item.isDefault)

            this.$mdDialog.hide({
                defaultMarket
            });
        }
    }

    angular.module("meevo.components.controls")
        .controller("meevo.components.controls.swapGroupMarkets.SwapGroupMarketsController", SwapGroupMarketsController);
}